<template>
  <div class="step-footer">
    <div class="headingarea">
      <h4 class="heading">
        <slot name="heading"></slot>
        <span v-if="badge" class="badge"><badge-icon class="-md -requires">{{badge}}</badge-icon></span>
      </h4>
    </div>
    <slot name="text"></slot>
  </div>
</template>

<script>

import BadgeIcon from '../badges/BadgeIcon'
export default {
  name: 'step-footer',
  components: {BadgeIcon},
  props: {
    badge: {type: String}
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.step-footer {
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  >.headingarea {
    @include flex(flex,space-between,flex-start,row,wrap);
    >.heading {
      font-size: 18px;
      font-weight: bold;
      @include mq-up(md){
        font-size: 24px;
      }
      >.badge {
        padding-left: 10px;
        @include mq-up(md){
          padding-left: 40px;
        }
      }
    }
  }
  .-orange & {
    background-color: $success;
  }
  .-green & {
    background-color: $twilight;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/steps/StepFooter.vue